
    var riot = require('riot')
    import context from 'static/script/app/ui/checkout2/context/context';
riot.tag2('checkout-shipping', '<div class="co-panel"> <h2>Leveransadress</h2> <div class="co-content"> <div class="co-shipping-content-left"> {model.streetName} <br> {model.zipCode}&nbsp;{model.town} <br> {model.country} <br> </div> <div class="co-shipping-content-right"> <div class="co-radio-new {co-radio-selected:IsSelected}" onclick="{selectShippingMethod}" each="{model.shippingOptions}"> <div class="header"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div if="{showShippingIcon(shippingType)}" class="{getShippingIconClass(shippingType)}"></div> <span if="{!showShippingIcon(shippingType)}">{displayText}</span> </div> <div class="cell-right"> +{shippingCost}&nbsp;kr </div> </div> </div> </div> <div style="clear: both"></div> </div> </div> <div class="co-panel-divider"></div>', '', '', function(opts) {
        this.model = opts.model;

        this.on('mount', function() {

        });

        var selectedItem = null;
        this.selectShippingMethod = function (event) {
            if (selectedItem) {
                selectedItem.IsSelected = false;
            }
            selectedItem = event.item;

            event.item.IsSelected = true;
            context.observable.trigger('shipping-changed', event.item);
        };

        this.selectShippingMethod({
            item: this.model.shippingOptions[0]
        });

        this.getShippingIconClass = function(shippingType) {
            return 'icon-' + shippingType.toLowerCase();
        }

        this.showShippingIcon = function(shippingType) {
            switch (shippingType.toLowerCase()) {
                case 'posten':
                case 'dhl':
                case 'schenkerprivpak':
                case 'bussgods':
                    return true;

                default:
                    return false;
                }
        }
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-shipping.riot.html